import React from 'react';
import { observer } from 'mobx-react-lite';
import NPAMiniLayout from './NPAMiniLayout';

const BidClientView = () => <NPAMiniLayout />;

export default observer(BidClientView);
